module.exports = __webpack_public_path__ + "static/media/img-6.90cfaec5.jpg";